import React from 'react';
import cx from 'classnames';

import s from './index.module.scss';

export type NotificationCardProps = {
  title: string;
  type: 'success' | 'warning' | 'error' | 'danger' | 'info';
  message: string;
  link?: string;
};

export const NotificationCard: React.FC<NotificationCardProps> = ({
  title,
  type,
  message,
  link,
}) => {
  return (
    <div
      className={cx(
        'flex flex-col items-start gap-4 py-16 pr-12 pl-20 w-full max-w-[356px] rounded-[8px] backdrop-blur-lg border border-[.5px] shadow bg-black-3',
        type === 'success' && 'border-success',
        type === 'error' && 'border-error',
        type === 'danger' && 'border-danger',
        type === 'info' && 'border-primary',
        type === 'warning' && 'border-warning'
      )}
    >
      <div className="flex items-center justify-between w-full text-m14">
        <span>{title}</span>
      </div>
      <span
        className={cx(s.description, 'text-r13 text-regular')}
        dangerouslySetInnerHTML={{
          __html: link ? `${message} <b><a href="${link}">Details</a></b>` : message,
        }}
      />
    </div>
  );
};
